(() => {
  if (window.__sizeGuideInitAttached) return
  window.__sizeGuideInitAttached = true

  const normalizeUnit = (unit) => {
    if (!unit) return 'in'
    const value = String(unit).toLowerCase().trim()
    if (value.startsWith('cm') || value.startsWith('cent')) return 'cm'
    if (value.startsWith('in')) return 'in'
    return 'in'
  }

  const parseJsonData = (element) => {
    if (!element) return null
    try {
      let data = JSON.parse(element.textContent)
      if (typeof data === 'string') {
        data = JSON.parse(data)
      }
      return data
    } catch (error) {
      return null
    }
  }

  const convertValue = (value, fromUnit, toUnit) => {
    if (fromUnit === toUnit) return value
    const multiplier = fromUnit === 'in' ? 2.54 : 1 / 2.54
    return String(value).replace(/\d+(?:\.\d+)?/g, (match) => {
      const numeric = Number.parseFloat(match)
      if (Number.isNaN(numeric)) return match
      const converted = Math.round(numeric * multiplier * 10) / 10
      return converted % 1 === 0 ? String(converted.toFixed(0)) : String(converted.toFixed(1))
    })
  }

  const getMeasuredColumnIndexes = (data) => {
    const columns = Array.isArray(data.columns) ? data.columns : []
    const customColumns = data.measure_columns || data.measureColumns
    if (Array.isArray(customColumns) && customColumns.length > 0) {
      const target = customColumns.map((name) => String(name).toLowerCase().trim())
      return columns
        .map((name, index) => (target.includes(String(name).toLowerCase().trim()) ? index : -1))
        .filter((index) => index >= 0)
    }
    return columns.map((_, index) => (index === 0 ? -1 : index)).filter((index) => index >= 0)
  }

  const renderTable = (tableFixed, tableScroll, data, displayUnit, measuredIndexes) => {
    tableFixed.innerHTML = ''
    tableScroll.innerHTML = ''

    const fixedHead = document.createElement('thead')
    const fixedHeaderRow = document.createElement('tr')
    const fixedHeaderCell = document.createElement('th')
    fixedHeaderCell.textContent = data.columns[0] ?? ''
    fixedHeaderRow.appendChild(fixedHeaderCell)
    fixedHead.appendChild(fixedHeaderRow)
    tableFixed.appendChild(fixedHead)

    const scrollHead = document.createElement('thead')
    const scrollHeaderRow = document.createElement('tr')
    data.columns.slice(1).forEach((column) => {
      const th = document.createElement('th')
      th.textContent = column
      scrollHeaderRow.appendChild(th)
    })
    scrollHead.appendChild(scrollHeaderRow)
    tableScroll.appendChild(scrollHead)

    const fixedBody = document.createElement('tbody')
    const scrollBody = document.createElement('tbody')

    data.rows.forEach((row, rowIndex) => {
      const fixedRow = document.createElement('tr')
      const scrollRow = document.createElement('tr')
      const isEven = rowIndex % 2 === 1
      if (isEven) {
        fixedRow.classList.add('size-guide__row--even')
        scrollRow.classList.add('size-guide__row--even')
      }

      const fixedCell = document.createElement('td')
      fixedCell.textContent = row[0] ?? ''
      fixedRow.appendChild(fixedCell)

      row.slice(1).forEach((cell, index) => {
        const td = document.createElement('td')
        const columnIndex = index + 1
        if (measuredIndexes.includes(columnIndex)) {
          td.textContent = convertValue(cell, data.baseUnit, displayUnit)
        } else {
          td.textContent = cell
        }
        scrollRow.appendChild(td)
      })

      fixedBody.appendChild(fixedRow)
      scrollBody.appendChild(scrollRow)
    })

    tableFixed.appendChild(fixedBody)
    tableScroll.appendChild(scrollBody)
  }

  const initContainer = (container) => {
    if (container.dataset.sizeGuideInitialized === 'true') return
    const jsonElement = container.querySelector('[data-size-guide-json]')
    const tableFixed = container.querySelector('[data-size-guide-table-fixed]')
    const tableScroll = container.querySelector('[data-size-guide-table-scroll]')
    const buttons = Array.from(container.querySelectorAll('[data-size-guide-unit]'))
    if (!jsonElement || !tableFixed || !tableScroll) return

    const data = parseJsonData(jsonElement)
    if (!data || !Array.isArray(data.columns) || !Array.isArray(data.rows)) return

    data.baseUnit = normalizeUnit(data.unit)
    const measuredIndexes = getMeasuredColumnIndexes(data)
    let currentUnit = data.baseUnit

    const setActiveButton = (unit) => {
      buttons.forEach((button) => {
        const isActive = button.dataset.sizeGuideUnit === unit
        button.classList.toggle('is-active', isActive)
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false')
      })
    }

    const updateTable = (unit) => {
      currentUnit = unit
      setActiveButton(unit)
      renderTable(tableFixed, tableScroll, data, unit, measuredIndexes)
    }

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const unit = button.dataset.sizeGuideUnit
        if (unit && unit !== currentUnit) {
          updateTable(unit)
        }
      })
    })

    updateTable(currentUnit)
    container.dataset.sizeGuideInitialized = 'true'
  }

  const initAll = (root = document) => {
    root.querySelectorAll('[data-size-guide]').forEach((container) => initContainer(container))
  }

  const handleMutations = (mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (!(node instanceof HTMLElement)) return
        if (node.hasAttribute('data-size-guide')) {
          initContainer(node)
          return
        }
        const nested = node.querySelectorAll?.('[data-size-guide]')
        if (nested && nested.length) {
          nested.forEach((container) => initContainer(container))
        }
      })
    })
  }

  const observer = new MutationObserver(handleMutations)
  observer.observe(document.documentElement, { childList: true, subtree: true })

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll())
  } else {
    initAll()
  }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => initAll(event.target))
  }
})()
